// JS

// export for others scripts to use
import $ from 'jquery'
import jQuery from 'jquery'
import FloatSidebar from 'float-sidebar'
import 'bootstrap/dist/js/bootstrap.min'
import 'popper.js/dist/popper.min'
import 'slick-carousel'
import 'slick-lightbox'

// import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import 'lightgallery.js/dist/js/lightgallery.min';
import 'lg-zoom.js/dist/lg-zoom';


window.jQuery = jQuery
window.$ = $

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

let token = document.head.querySelector('meta[name="csrf-token"]')
console.log(token.content)
if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

/**
 * Fire a lead/goal event on a successful form submit.
 *
 * The event is pushed into the dataLayer instead of being sent with gtag()
 * directly, so Google Tag Manager picks it up and fans it out to GA4 and
 * Google Ads. The GTM container must have a Custom Event trigger on
 * "generate_lead" wired to those tags — nothing is sent otherwise.
 *
 * IMPORTANT: never pass PII (name, email, phone) here — Google policy forbids
 * sending it to Analytics/Ads. Only non-PII params (service, contact method,
 * source, whether photos were attached, etc.). Params are readable in GTM as
 * Data Layer Variables of the same name.
 *
 * @param {Object} params  Extra event params (non-PII).
 */
window.trackLead = function (params = {}) {
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push(Object.assign({
    event: 'generate_lead',
    currency: 'USD',
    value: 1,
  }, params))
}

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

document.addEventListener('DOMContentLoaded', () => {
  /*let menuItems = $('.nav-item')
  menuItems.mouseover((e) => {
    $(e.currentTarget).find('.nav-link.dropdown-toggle').dropdown('show')
  })
  menuItems.mouseleave((e) => {
    $(e.currentTarget).find('.nav-link.dropdown-toggle').dropdown('hide')
  })
  $('.nav-link.dropdown-toggle').on('click', (e) => {
    console.log(e)
    e.preventDefault(true)
  })*/

  function toggleDropdown (e) {
    const _d = $(e.target).closest('.dropdown'),
      _m = $('.dropdown-menu', _d);
    setTimeout(function(){
      const shouldOpen = e.type !== 'click' && _d.is(':hover');
      _m.toggleClass('show', shouldOpen);
      _d.toggleClass('show', shouldOpen);
      $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
    },0);
  }

  function togglePhone(e) {
    $('#myTextPhone a').text($(e.currentTarget).data('value')).attr('href', $(e.currentTarget).attr('href'))
  }

  $('body')
  .on('mouseenter mouseleave','.dropdown',toggleDropdown)
  .on('click', '.dropdown-menu a', toggleDropdown)
    .on('click', '.phone-dropdown a', togglePhone);

  /* not needed, prevents page reload for SO example on menu link clicked */
  // $('.dropdown a').on('click tap', e => e.preventDefault())


  $('.catalog-filter__list select').change(function () {
    let text = $(this).find('option:selected').text()
    let $aux = $('<select/>').append($('<option/>').text(text))
    $(this).after($aux)
    $(this).width(function () {
      return $aux.width()
    })
    $aux.remove()
  }).change()

  $('.form-search__input').on('focus', function (evt) {
    $('#header__nav').addClass('search-open')
  })

  jQuery(function ($) {
    $(document).mouseup(function (e) {
      let div = $('.form-search')
      if (!div.is(e.target) && div.has(e.target).length === 0) {
        $('#header__nav').removeClass('search-open')
      }
    })
  })

  $('.form-search').click(function () {
    $('#header__nav').addClass('search-open-mobil')
  })

  $('.form-search__bg-close').click(function () {
    $('.header__nav').removeClass('search-open-mobil')
  })

  $('.navbar-toggler').click(function () {
    $('html').toggleClass('overflow-hidden')
    $('#wrapper').toggleClass('menu-open')
  })

  $('.dropdown-toggle').on('hide.bs.dropdown', function () {
    return false
  })

  $('.navbar-nav .dropdown-toggle .dropdown-menu').on({
    'click': function (e) {
      e.stopPropagation()
    },
  })

  $('.product-page__order-favorites').click(function () {
    $(this).toggleClass('active')
  })

  $('.dropdown-menu li a').click(function () {
    $(this).parents('.dropdown').find('.btn').val($(this).data('value')).html($(this).html())
  })

  $('.phone-icon-mob').click(function () {
    $('#header__nav').addClass('phone-mobil-active')
  })

  $('.phone-mobil-container_bg, .phone-mobil-container button').click(function () {
    $('#header__nav').removeClass('phone-mobil-active')
  })

  $(document).on('click.bs.dropdown.data-api', '.noclose', function (e) { e.stopPropagation() })

  let header = $('#header')
  let scrollPrev = 0

  $(window).scroll(function () {

    let scrolled = $(window).scrollTop()

    // if (scrolled > 80 && scrolled > scrollPrev) {
    //   header.addClass('out')
    // } else {
    //   header.removeClass('out')
    // }

    if (scrolled > 150) {
      header.addClass('header__home-page')
    } else {
      header.removeClass('header__home-page')
    }

    scrollPrev = scrolled
  })

  function slickNum () {
    let $status = $('.pagingInfo')
    let $slickElement = $('.home-section-firstSlide__slider')

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      let i = (currentSlide ? currentSlide : 0) + 1
      $status.text(`0${i}`)
    })

    $slickElement.slick({
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: false,
      autoplay: true,
      autoplaySpeed: 15000,
      arrows: false,
      fade: true,
      cssEase: 'ease-in-out',
      speed: 500,
      dots: true,
    })

    // imgSize();
  }

  (function slickAdd () {
    $('.catalog-slider__list').slick({
      infinite: false,
      slidesToShow: 3,
      variableWidth: true,
      arrow: true,
      lazyLoad: 'progressive',
      dots: false,
      adaptiveHeight: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            variableWidth: false,
            infinite: true,
          },
        },
        {
          breakpoint: 767.98,
          settings: {
            variableWidth: false,
            slidesToShow: 2,
            infinite: true,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
            infinite: true,
          },
        },
      ],
    })

    $('.about-section-slider').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrow: true,
      lazyLoad: 'progressive',
      dots: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
          },
        },
        {
          breakpoint: 767.98,
          settings: {
            variableWidth: false,
            slidesToScroll: 1,
            slidesToShow: 2,
            infinite: true,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
      ],
    })

    $('.home-products-slider').slick({
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrow: true,
      lazyLoad: 'progressive',
      swipeToSlide: true,
      dots: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 991.98,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
      ],
    })

    $('.home-reviews-slider').slick({
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      swipeToSlide: true,
      dots: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1199.98,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 991.98,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
      ],
    })

    $('.inner-page-slider').slick({
      centerMode: false,
      slidesToShow: 4,
      infinite: false,
      arrow: true,
      lazyLoad: 'progressive',
      swipeToSlide: true,
      dots: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
          },
        },
        {
          breakpoint: 767.98,
          settings: {
            variableWidth: false,
            slidesToScroll: 1,
            slidesToShow: 2,
            infinite: true,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
          },
        },
      ],
    })

    $('.text-page-bottom-section__slider').slick({
      slidesToShow: 2,
      infinite: false,
      arrow: true,
      lazyLoad: 'progressive',
      dots: true,
      adaptiveHeight: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767.98,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })

    $('.product-image__list').each(function () {
      let slider = $(this)
      slider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
      })

      // $('#gallery-btn').on('click', function () {
      //   $.fancybox.open($('.product-image__hidden-item'), {
      //       buttons : [
      //           'slideShow',
      //           'fullScreen',
      //           'close',
      //       ]
      //   })
      // })

    })

    slickNum()
  })()

  lightGallery(document.getElementById('lightgallery'));

    $('#gallery-btn').on('click', function() {
        // $.fancybox.open( $('.product-image__hidden-item'), {});
        $('.product-image__hidden-item img').click()
    });

// SIDEBAR

  let sidebar = document.querySelector('.sidebar')
  let content = document.querySelector('.content-sideBar')

  if (sidebar && content) {
    let floatSidebar = FloatSidebar({
      sidebar: sidebar,
      relative: content,
      topSpacing: 90,
      bottomSpacing: 40,
    })

    sidebar.addEventListener('click', function (e) {
      let target = e.target

      if (target.matches('.sidebar__section')) {
        target.classList.toggle('is-opened')
      }

      floatSidebar.forceUpdate()
    })
  }

})

// SCSS
// import './assets/scss/main.scss'

// CSS (example)
// import './assets/css/main.css'


